<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-card>
        <div class="pa-3">
          <v-card-title>
            <v-text-field v-model="search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="header" :items="data_list" key="index" item-key="product_code" :footer-props="footer_Props" :search="search" mobile-breakpoint="0" :items-per-page="itemPerPage">
            <template slot="item" slot-scope="dataDetail">
              <tr>
                <td>{{ dataDetail.item.product_code }}</td>
                <td>{{ dataDetail.item.product_name }}</td>
                <td>{{ dataDetail.item.product_name_sci }}</td>
                <td>{{ format_number(dataDetail.item.mains) }}</td>
                <td>{{ format_number(dataDetail.item.expireds) }}</td>
                <td>{{ format_number(dataDetail.item.damages) }}</td>
                <td>{{ format_number(dataDetail.item.returns) }}</td>
                <td>{{ format_number(dataDetail.item.reducts) }}</td>
                <td>{{ format_number(dataDetail.item.dumps) }}</td>
                <td>{{ format_number(dataDetail.item.promotions) }}</td>
                <td>{{ dataDetail.item.unit_name }}</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@/js/handler";
import {HTTP} from "@/axios";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Warehouse_quantity",
  data() {
    return {
      loading_page: false,
      search: '',
      itemPerPage: -1,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รหัสสินค้า',
          value: 'product_code',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '260px',
        },
        {
          text: 'ชื่อทางวิทยาศาสตร์',
          value: 'product_name_sci',
          fixed: true,
          width: '200px',
        },
        {
          text: 'คลังหลัก',
          value: 'mains',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังใกล้หมดอายุ',
          value: 'expireds',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังชำรุด',
          value: 'damages',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังรอคืน',
          value: 'returns',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังรอลดหนี้',
          value: 'reducts',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังทิ้ง',
          value: 'dumps',
          fixed: true,
          width: '180px',
        },
        {
          text: 'คลังโปรโมชั่น',
          value: 'promotions',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit_name',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    async get_data_table() {
      this.loading_page = true
      await HTTP.post('/inventory/dashboards/productswarehouse', {
        limit: 1
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.data_list = res.data.object
        }
      })
    },
  },
  mounted() {
    this.get_data_table()
  }
}
</script>

<style scoped>

</style>
